import { render } from "./InterfaceSidebar.vue?vue&type=template&id=0afde10c&scoped=true"
import script from "./InterfaceSidebar.vue?vue&type=script&lang=js"
export * from "./InterfaceSidebar.vue?vue&type=script&lang=js"

import "./InterfaceSidebar.vue?vue&type=style&index=0&id=0afde10c&scoped=true&lang=scss"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afde10c"]])

export default __exports__